<!--
  - Copyright (c) 2022 by Leyton Group - All Rights Reserved.
  - This source code, and resulting software, is the confidential and proprietary information
  - ("Proprietary Information") and is the intellectual property ("Intellectual Property")
  - of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
  - and shall use it only in accordance with the terms and conditions of any and all license
  - agreements you have entered into with The Company.
  -->

<template>
  <div id="notifications">
    <div class="giga-content_container">
      <div class="accordion" role="tablist">
        <div class="giga-accordion_row">
          <div class="accordion-row_header" header-tag="header" role="tab">
            <b-button block v-b-toggle.accordion-ouvrages>
              <i class="accordion-row_icon">
                <svg
                  width="9"
                  height="6"
                  viewBox="0 0 9 6"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M5.24537e-08 5.4C2.30796e-08 5.736 0.2475 6 0.5625 6L8.4375 6C8.7525 6 9 5.736 9 5.4C9 5.244 8.94375 5.112 8.85375 5.004C8.76375 4.896 4.91625 0.204 4.91625 0.204C4.815 0.0839997 4.66875 -3.7865e-07 4.5 -3.93402e-07C4.33125 -4.08155e-07 4.185 0.0839997 4.08375 0.204L0.14625 5.004C0.0562497 5.112 6.60916e-08 5.244 5.24537e-08 5.4Z"
                    fill="#132D48"
                  />
                </svg>
              </i>
              Ouvrages</b-button
            >
          </div>
          <b-collapse
            class="accordion-tabpanel"
            id="accordion-ouvrages"
            accordion="acces-row"
            role="tabpanel"
            visible
          >
            <ul class="accordion-panel_header">
              <li class="accordion-item accordion-multi_choices">
                <div class="accordion-item_name">Tous les ouvrages</div>
                <ul>
                  <li>
                    <div class="giga-custom_checkbox" :class="classObject">
                      <input
                        type="checkbox"
                        name="messages"
                        v-model="allRowsSelected"
                        @change="allMessagesSelected('ouvrages')"
                      />
                      <label></label>
                      <span>Messages</span>
                    </div>
                  </li>
                  <li>
                    <div class="giga-custom_checkbox">
                      <input type="checkbox" name="status" />
                      <label></label>
                      <span>Statuts</span>
                    </div>
                  </li>
                </ul>
              </li>
            </ul>
            <ul class="accordion-items_list">
              <li
                v-for="(ouvrage, index) in ouvrages"
                :key="index"
                class="
                  accordion-item
                  accordion-multi_choices accordion-multi_choices
                "
              >
                <div class="accordion-item_name">{{ ouvrage.name }}</div>
                <ul>
                  <li>
                    <div class="giga-custom_checkbox">
                      <input
                        type="checkbox"
                        name="messages"
                        v-model="selectedRow"
                        :value="ouvrage.id"
                      />
                      <label></label>
                      <span>Messages</span>
                    </div>
                  </li>
                  <li>
                    <div class="giga-custom_checkbox">
                      <input type="checkbox" name="status" />
                      <label></label>
                      <span>Statuts</span>
                    </div>
                  </li>
                </ul>
              </li>
            </ul>
          </b-collapse>
        </div>

        <div class="giga-accordion_row">
          <div class="accordion-row_header" header-tag="header" role="tab">
            <b-button block v-b-toggle.accordion-simulations>
              <i class="accordion-row_icon">
                <svg
                  width="9"
                  height="6"
                  viewBox="0 0 9 6"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M5.24537e-08 5.4C2.30796e-08 5.736 0.2475 6 0.5625 6L8.4375 6C8.7525 6 9 5.736 9 5.4C9 5.244 8.94375 5.112 8.85375 5.004C8.76375 4.896 4.91625 0.204 4.91625 0.204C4.815 0.0839997 4.66875 -3.7865e-07 4.5 -3.93402e-07C4.33125 -4.08155e-07 4.185 0.0839997 4.08375 0.204L0.14625 5.004C0.0562497 5.112 6.60916e-08 5.244 5.24537e-08 5.4Z"
                    fill="#132D48"
                  />
                </svg>
              </i>
              Simulations</b-button
            >
          </div>
          <b-collapse
            class="accordion-tabpanel"
            id="accordion-simulations"
            accordion="acces-row"
            role="tabpanel"
          >
            <ul class="accordion-panel_header">
              <li class="accordion-item accordion-multi_choices">
                <div class="accordion-item_name">Tous les simulations</div>
                <ul>
                  <li>
                    <div class="giga-custom_checkbox" :class="classObject">
                      <input
                        type="checkbox"
                        name="messages"
                        v-model="allRowsSelected"
                        @change="allMessagesSelected('simulations')"
                      />
                      <label></label>
                      <span>Messages</span>
                    </div>
                  </li>
                  <li>
                    <div class="giga-custom_checkbox">
                      <input type="checkbox" name="status" />
                      <label></label>
                      <span>Statuts</span>
                    </div>
                  </li>
                </ul>
              </li>
            </ul>
            <ul class="accordion-items_list">
              <li
                v-for="(simulation, index) in simulations"
                :key="index"
                class="
                  accordion-item
                  accordion-multi_choices accordion-multi_choices
                "
              >
                <div class="accordion-item_name">{{ simulation.name }}</div>
                <ul>
                  <li>
                    <div class="giga-custom_checkbox">
                      <input
                        type="checkbox"
                        name="messages"
                        v-model="selectedRow"
                        :value="simulation.id"
                      />
                      <label></label>
                      <span>Messages</span>
                    </div>
                  </li>
                  <li>
                    <div class="giga-custom_checkbox">
                      <input type="checkbox" name="status" />
                      <label></label>
                      <span>Statuts</span>
                    </div>
                  </li>
                </ul>
              </li>
            </ul>
          </b-collapse>
        </div>

        <div class="giga-accordion_row">
          <div class="accordion-row_header" header-tag="header" role="tab">
            <b-button block v-b-toggle.accordion-facturations>
              <i class="accordion-row_icon">
                <svg
                  width="9"
                  height="6"
                  viewBox="0 0 9 6"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M5.24537e-08 5.4C2.30796e-08 5.736 0.2475 6 0.5625 6L8.4375 6C8.7525 6 9 5.736 9 5.4C9 5.244 8.94375 5.112 8.85375 5.004C8.76375 4.896 4.91625 0.204 4.91625 0.204C4.815 0.0839997 4.66875 -3.7865e-07 4.5 -3.93402e-07C4.33125 -4.08155e-07 4.185 0.0839997 4.08375 0.204L0.14625 5.004C0.0562497 5.112 6.60916e-08 5.244 5.24537e-08 5.4Z"
                    fill="#132D48"
                  />
                </svg>
              </i>
              Facturations</b-button
            >
          </div>
          <b-collapse
            class="accordion-tabpanel"
            id="accordion-facturations"
            accordion="acces-row"
            role="tabpanel"
          >
            <ul class="accordion-panel_header">
              <li class="accordion-item accordion-multi_choices">
                <div class="accordion-item_name">Tous les simulations</div>
                <ul>
                  <li>
                    <div class="giga-custom_checkbox" :class="classObject">
                      <input
                        type="checkbox"
                        name="messages"
                        v-model="allRowsSelected"
                        @change="allMessagesSelected('facturations')"
                      />
                      <label></label>
                      <span>Messages</span>
                    </div>
                  </li>
                  <li>
                    <div class="giga-custom_checkbox">
                      <input type="checkbox" name="status" />
                      <label></label>
                      <span>Statuts</span>
                    </div>
                  </li>
                </ul>
              </li>
            </ul>
            <ul class="accordion-items_list">
              <li
                v-for="(facturation, index) in facturations"
                :key="index"
                class="
                  accordion-item
                  accordion-multi_choices accordion-multi_choices
                "
              >
                <div class="accordion-item_name">{{ facturation.name }}</div>
                <ul>
                  <li>
                    <div class="giga-custom_checkbox">
                      <input
                        type="checkbox"
                        name="messages"
                        v-model="selectedRow"
                        :value="facturation.id"
                      />
                      <label></label>
                      <span>Messages</span>
                    </div>
                  </li>
                  <li>
                    <div class="giga-custom_checkbox">
                      <input type="checkbox" name="status" />
                      <label></label>
                      <span>Statuts</span>
                    </div>
                  </li>
                </ul>
              </li>
            </ul>
          </b-collapse>
        </div>
      </div>
    </div>
    <div class="giga-document_footer giga-margin-t_65 giga-flex giga-flex_end">
      <div class="giga-button">
        <b-button class="giga-blue_outlined_button no-icon">Réinitialiser</b-button>
      </div>
      <div class="giga-button">
        <b-button class="giga-green_button no-icon">{{$t("update")}}</b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "Notifications",
  data: function () {
    return {
      scrollBarSettings: {
        scrollXMarginOffset: 50,
      },
      selectedRow: [],
      allRowsSelected: false,
      ouvrages: [
        {
          id: 1,
          name: "Ouvrage n°1",
        },
        {
          id: 2,
          name: "Ouvrage n°2",
        },
        {
          id: 3,
          name: "Ouvrage n°3",
        },
      ],
      simulations: [
        {
          id: 1,
          name: "Simulation n°1",
        },
        {
          id: 2,
          name: "Simulation n°2",
        },
        {
          id: 3,
          name: "Simulation n°3",
        },
        {
          id: 4,
          name: "Simulation n°4",
        },
        {
          id: 5,
          name: "Simulation n°5",
        },
      ],
      facturations: [
        {
          id: 1,
          name: "Facturation n°1",
        },
        {
          id: 2,
          name: "Facturation n°2",
        },
        {
          id: 3,
          name: "Facturation n°3",
        },
        {
          id: 4,
          name: "Facturation n°4",
        },
        {
          id: 5,
          name: "Facturation n°5",
        },
      ],
    };
  },
  computed: {
    classObject() {
      return {
        indeterminateRows:
          this.selectedRow.length >= 1 &&
          this.selectedRow.length < this.ouvrages.length,
        allSelected: this.selectedRow.length == this.ouvrages.length,
      };
    },
  },
  methods: {
    allMessagesSelected(value) {
      if (this.allRowsSelected) {
        const selectedRow = this[value].map((item) => item.id);
        this.selectedRow = selectedRow;
      } else {
        this.selectedRow = [];
      }
    },
  },
};
</script>

<style scoped>
</style>